export default __webpack_public_path__ + "img/b2.baefaa73.png";